import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-quejas-reclamos',
  templateUrl: './quejas-reclamos.component.html',
  styleUrls: ['./quejas-reclamos.component.scss']
})
export class QuejasReclamosComponent{

  constructor(private loginService:LoginService){}

    clickGuard(){
      this.loginService.clickGuard = true;
   }

}
